import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

const ReportCamerasOnHireData = (props: RouteComponentProps<{}>) => {
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunReports&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
            .then(res => {
                if (res.data == true) {
                    setLoading(false);
                } else if (res.data == false) {
                    //redirect to 403 permission denied
                    props.history.push("/accessdenied")
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data
        runRpt();
    }

    const runRpt = () => {
        var url = "/report/CamerasOnHire/-1/-1/-1/-1/-1";
        window.open(url, '_blank');
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Cameras On Hire Report</h1>
            </div>
            <div>
                <button className="defaultbutton" type='button' onClick={runReport}>Run Report</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

}

export default ReportCamerasOnHireData;